import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Button, message, Tag, notification } from "antd"
import { listBatchesV4, markMex } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'

function MexPage() {
    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [listBatch, setListBatch] = useState([])

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        const checkValue = /^\w+-\d/.test(valueInput)
        if (!checkValue || !valueInput.trim()) {
            setErrorInput('Mã lô sai định dạng.')
            setLoading(false)
        }

        if (checkValue && valueInput.trim()) {
            try {
                const { data } = await listBatchesV4({ name: valueInput })
                const { data: res } = Object.assign({}, data)
                const { batches } = res

                if (!batches.length > 0) return Modal.error({
                    title: 'Lỗi',
                    content: 'Không tìm thấy tên lô',
                    onOk: _resetScanInput(),
                    okText: 'Đóng'
                })

                const { status, name } = Object.assign({}, ...batches)

                if (!['wait_to_sew', 'sewing'].includes(status)) return message.error(`Lô ${name} đang ở trạng thái ${status}, không thể ép mex.`)
                const uniqueBatches = [...new Map([...listBatch, ...batches].map(batch => [batch._id, batch])).values()]

                if (uniqueBatches.length > 100) return message.error("Đánh dấu ép mex tối đa 100 lô.")

                setListBatch(uniqueBatches)

            } catch (error) {
                setErrorInput(error)
            } finally {
                setLoading(false)
                setValueInput('')
                _input.current.focus()
            }
        }
    }

    const _removeBatch = (batchId) => {
        const newBatchs = listBatch.filter(batch => batch._id !== batchId) || []
        setListBatch(newBatchs)
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const handleMex = async () => {
        setLoading(true)

        try {
            let results = []

            await Promise.all(listBatch.map(async item => {
                const { data: response } = await markMex(item._id)

                const { success, error } = Object.assign({}, response)

                if (!success) return results.push({ success: false, batchId: item._id, error, batchName: item.name })
                return results.push({ success: true, batchId: item._id, name: item.name })
            }))

            let newListSuccess = []
            let newListError = []

            results.forEach(result => {
                if (result.success === true) {
                    newListSuccess.push(result.name)
                }

                if (result.success === false) {
                    newListError.push(result)
                }
            })

            if (newListError.length === 0) {
                notification.success({
                    message: `Đánh dấu ép mex thành công.`,
                })
                setListBatch([])
            } else {
                Modal.info({
                    title: <h4>Kết quả đánh dấu ép mex</h4>,
                    content: (
                        <div>
                            {
                                !!newListSuccess.length && (
                                    <div className="mt-2">
                                        <h5 className="text-success">Đánh dấu thành công:</h5>
                                        <ul className="pl-4 list-disc">
                                            {newListSuccess.map(name => (
                                                <li key={name}>{name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                            }

                            {
                                !!newListError.length && (
                                    <div className="mt-2">
                                        <h5 className="text-danger">Đánh dấu thất bại:</h5>
                                        <ul className="pl-4 list-disc">
                                            {newListError.map(i => (
                                                <li key={i.batchId}>{`${i.batchName}: ${i.error}`}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                            }
                        </div>
                    ),
                    okText: 'Đóng',
                    onOk: () => setListBatch([])
                })
            }

            _resetScanInput()

        } catch (error) {
            message.error(error)
        } finally {
            setLoading(false)
        }
    }

    const _handleSubmitMex = () => {
        handleMex()
    }


    return (
        <div className='MexPage py-5'>
            <div className="col-12 mx-auto px-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1 className="PageTitle">Đánh dấu ép mex</h1>
                    <label className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6">
                        <NavLink exact to='/list-mex' className='nav-link p-0'>
                            Danh sách ép mex
                        </NavLink>
                    </label>
                </div>
                <div className="site-layout-background pb-4">
                    <div className="UpdateLazeCutting">
                        <div className="UpdateLazeCuttingPage">
                            <div className="position-relative">
                                <Spin tip='Đang kiểm tra...' spinning={loading}>
                                    <form className="formQC" onSubmit={_onSubmit}>
                                        <Input
                                            style={{ fontSize: 40, height: "auto" }}
                                            ref={_input}
                                            autoFocus={true}
                                            placeholder='Nhập vào tên lô'
                                            onChange={_handleChangeScan}
                                            value={valueInput.toUpperCase()}
                                        />

                                        {
                                            loading &&
                                            <Icon type="sync" spin className="position-absolute IconInput" />
                                        }

                                        {
                                            valueInput &&
                                            <Icon
                                                type='close-circle'
                                                className="position-absolute cursor-pointer text-dark IconInput"
                                                onClick={_resetScanInput}
                                            />
                                        }

                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="batch_tag">
                                                {
                                                    !!listBatch.length &&
                                                    listBatch.map((batch) => {
                                                        return (
                                                            <Tag
                                                                closable
                                                                onClose={() => _removeBatch(batch._id)}
                                                                key={batch._id}
                                                            >{batch.name}
                                                            </Tag>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div>
                                                {
                                                    (!loading) && !!listBatch.length &&
                                                    <Button
                                                        className='float-right mt-3 px-4'
                                                        onClick={_handleSubmitMex}
                                                        type='primary'
                                                    >
                                                        Xác nhận ép mex
                                                    </Button>
                                                }
                                            </div>
                                        </div>
                                    </form>

                                    {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MexPage